import React, {useEffect, useState, useContext} from 'react'
import moment from 'moment'
import _ from 'lodash'
import Gantt from './Gantt'
import {ReservationCalendarMainContext} from '../../context/ReservationCalendarMain'
import response_data from './response.json'

const ReservationGantt = ({expanded = false}) => {
  const [currentDate] = useState(moment())
  const {sliderLength} = useContext(ReservationCalendarMainContext)

  return <Gantt currentDate={currentDate} viewSecLength={sliderLength} />
}

export default ReservationGantt
